import React from 'react'
import listEmpty from '@/static/imgs/table-empty.png'
import styles from './index.module.less'

interface TableEmptyProps {
  children?: React.ReactNode
  src?: string
  style?: Record<string, string>
  title?: string
  desc?: string
}
const TableEmpty = (props: TableEmptyProps) => {
  const { children, title, desc, src = listEmpty, style = { width: '176px', height: '176px' } } = props
  return (
    <div className={styles.empty}>
      <div className={styles.emptyContainer}>
        <img src={src} alt="empty" style={style} />
        {title && <p style={{ color: '#001529', fontSize: '20px', marginTop: '40px', marginBottom: '12px', fontWeight: 600 }}>{title}</p>}
        {desc && <p style={{ color: '#7a8499', fontSize: '16px' }}>{desc}</p>}
        {children}
      </div>
    </div>
  )
}

export default TableEmpty
